// extracted by mini-css-extract-plugin
export default {"home_page_wrapper":"Home_home_page_wrapper__tQE7V"};